<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-12-02 10:12:02
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-12-24 10:51:21
 * @Description: 
-->
<template>
  <el-dialog
    title="文件预览"
    :visible="dialogVisible"
    width="70%"
    :before-close="handleClose"
    class="dialog"
  >
    <div class="pdfContainer">
      <iframe :src="iframePath" class="iframe"></iframe>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { imgSrcGetBase64 } from "@/common/js/api.js";
export default {
  props: ["dialogVisible", "path"],

  data() {
    return {
      iframePath: "",
    };
  },

  methods: {
    handleClose() {
      this.$emit("closeDialog");
    },
  },

  watch: {
    path(newValue) {
      if (newValue) {
        async () => {
          const { result } = await imgSrcGetBase64(newValue);
          this.iframePath = result;
        };
      }
    },
  },
};
</script>

<style scoped>
.dialog >>> .el-dialog__body {
  height: 600px !important;
  padding: 0px !important;
}

.pdfContainer {
  height: 100%;
}

.iframe {
  width: 100%;
  height: 100%;
}
</style>
